
import request from "@/utils/request"

//获取绑定交易所名单
export function getBindings() {
    return request({
        method: 'get',
        url: 'actual/binding/',
        headers: {
            token: localStorage.getItem("token")
        }
    })

}

// 更新绑定信息
export function sendBindingUpdate(data) {
    return request({
        method: 'post',
        url: 'actual/binding/update/',
        data,
        headers: {
            token: localStorage.getItem("token")
        }
    })

} 

// 获取交易所信息
export function getBindingExchange() {
    return request({
        method: 'get',
        url: 'actual/binding/exchange/',
    })

}

// 新增绑定交易所api
export function sendBinding(data) {
    return request({
        method: 'post',
        url: 'actual/binding/',
        data,
        headers: {
            token: localStorage.getItem("token")
        }
    })

} 
//获取允许用户查看资产及持仓的权限
export function getPersonalPermission() {
    return request({
        method: 'get',
        url: 'actual/personal/permission/',
        headers: {
            token: localStorage.getItem("token")
        }
    })

}

//修改允许用户查看资产及持仓的权限
export function sendPersonalPermission(data) {
    return request({
        method: 'post',
        url: 'actual/personal/permission/',
        data,
        headers: {
            token: localStorage.getItem("token")
        }
    })

} 

//删除绑定的apikey信息
export function deleteBinding(data) {
    return request({
        method: 'post',
        url: 'actual/binding/delete/',
        data,
        headers: {
            token: localStorage.getItem("token")
        }
    })

}

//删除绑定的apikey信息后请求列表
export function getBindingList(data) {
    return request({
        method: 'post',
        url: 'actual/binding/list/',
        data,
        headers: {
            token: localStorage.getItem("token")
        }
    })

}




// WEBPACK FOOTER //
// ./src/api/apiKey.js